import * as THREE from "three";
import _ from "lodash";
import async from "async";
import { Howl } from "howler";
import { useFrame, useLoader } from "@react-three/fiber";
import { Suspense, useEffect, useRef, useState } from "react";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { useAnimations } from "@react-three/drei";

const playBackSpeed = 1;

const getVisemeAnimation = (actions, value) => {
  let res;
  switch (value) {
    case "k":
      res = "amazonPolly_phoneme_k_g_ng";
      break;
    case "a":
    case "@":
      res = "amazonPolly_phoneme_aa";
      break;
    case "sil":
      res = "defaultExpressions_Neutral";
      break;
    case "t":
    case "T":
      res = "amazonPolly_phoneme_d_t_n";
      break;
    case "s":
    case "S":
      res = "amazonPolly_phoneme_s_z";
      break;
    case "o":
    case "O":
      res = "amazonPolly_phoneme_ow";
      break;
    case "p":
      res = "amazonPolly_phoneme_p_b_m";
      break;
    case "E":
    case "e":
      res = "amazonPolly_phoneme_ey_eh_uh";
      break;
    case "u":
      res = "amazonPolly_phoneme_w_uw";
      break;
    case "i":
      res = "amazonPolly_phoneme_y_iy_ih_ix";
      break;
    case "f":
      res = "amazonPolly_phoneme_f_v";
      break;
  }
  return actions[res];
};

// export function getMouseDegrees(x, y, degreeLimit) {
//   let dx = 0,
//     dy = 0,
//     xdiff,
//     xPercentage,
//     ydiff,
//     yPercentage;

//   // @ts-ignore
//   let w = { x: window.innerWidth, y: window.innerHeight };

//   // Left (Rotates neck left between 0 and -degreeLimit)
//   // 1. If cursor is in the left half of screen
//   if (x <= w.x / 2) {
//     // 2. Get the difference between middle of screen and cursor position
//     xdiff = w.x / 2 - x;
//     // 3. Find the percentage of that difference (percentage toward edge of screen)
//     xPercentage = (xdiff / (w.x / 2)) * 100;
//     // 4. Convert that to a percentage of the maximum rotation we allow for the neck
//     dx = ((degreeLimit * xPercentage) / 100) * -1;
//   }

//   // Right (Rotates neck right between 0 and degreeLimit)
//   if (x >= w.x / 2) {
//     xdiff = x - w.x / 2;
//     xPercentage = (xdiff / (w.x / 2)) * 100;
//     dx = (degreeLimit * xPercentage) / 100;
//   }
//   // Up (Rotates neck up between 0 and -degreeLimit)
//   if (y <= w.y / 2) {
//     ydiff = w.y / 2 - y;
//     yPercentage = (ydiff / (w.y / 2)) * 100;
//     // Note that I cut degreeLimit in half when she looks up
//     dy = ((degreeLimit * 0.5 * yPercentage) / 100) * -1;
//   }
//   // Down (Rotates neck down between 0 and degreeLimit)
//   if (y >= w.y / 2) {
//     ydiff = y - w.y / 2;
//     yPercentage = (ydiff / (w.y / 2)) * 100;
//     dy = (degreeLimit * yPercentage) / 100;
//   }
//   return { x: dx, y: dy };
// }

// function moveJoint(mouse, joint, degreeLimit = 40) {
//   // console.log(mouse)

//   let degrees = getMouseDegrees(mouse.x, mouse.y, degreeLimit);

//   joint.rotation.xD = THREE.MathUtils.lerp(
//     joint.rotation.xD || 0,
//     degrees.y,
//     0.1
//   );
//   joint.rotation.yD = THREE.MathUtils.lerp(
//     joint.rotation.yD || 0,
//     degrees.x,
//     0.1
//   );
//   joint.rotation.x = joint.rotation.xD * 0.0174533; // THREE.Math.degToRad(joint.rotation.xD)
//   joint.rotation.y = joint.rotation.yD * 0.0174533; //THREE.Math.degToRad(joint.rotation.yD)
// }

export default function Avatar({ modelPath, currentPolly, play }) {
  const mesh = useRef();
  const { scene, animations, nodes } = useLoader(GLTFLoader, modelPath);
  const [sound, setSound] = useState(null);
  //   let sound = null;

  const { actions } = useAnimations(animations, scene);
  console.log(actions, nodes);

  scene.position.y = 0;

  useEffect(() => {
    setSound(
      new Howl({
        src: [currentPolly.polly.audioUrl],
        volume: 1,
        rate: playBackSpeed,
        onend: function () {},
      })
    );
  }, [currentPolly]);

  useEffect(() => {
    // TODO - weird check to avoid unnecessary plays
    if (play && sound && (!window.playNum || window.playNum < play)) {
      sound.play();
      window.timing = 0;
      async.eachSeries(
        currentPolly.polly.viseme,
        animateLetter,
        function (err, results) {
          if (err) {
            console.log(err);
          } else {
            console.log(results);
          }
        }
      );
    }
    window.playNum = play;
  }, [play]);

  console.log("-> cp ", currentPolly, modelPath);

  function animateLetter(letter, callback) {
    const t = letter.time * (1 + (1 - playBackSpeed));
    let time = t - window.timing;
    window.timing = t;

    console.log(" Start --->", letter.value, time);

    let action = getVisemeAnimation(actions, letter.value);
    action.loop = THREE.LoopOnce;
    action.clampWhenFinished = true;

    window.fadeToAction(action, time / 1000);

    setTimeout(() => {
      console.log(" END --->", letter.value);
      callback(null, letter.value);
    }, time);
  }

  const playIdle = (timescale = 0.65) => {
    if (!actions.IDLE_01) return;
    actions.IDLE_01.loop = THREE.LoopPingPong;
    actions.IDLE_01.timeScale = timescale;

    actions.IDLE_01.reset().play();
  };

  // -----> Idle
  useEffect(() => {
    function loop() {
      const rand = Math.round(Math.random() * (3000 - 500)) + 500;
      console.log("--> Blink timing ", rand);

      setTimeout(function () {
        let actionRight = actions.ARKit_eyeBlinkRight;
        actionRight.loop = THREE.LoopOnce;
        actionRight.reset().setDuration(0.2).play();

        let actionLeft = actions.ARKit_eyeBlinkLeft;
        actionLeft.loop = THREE.LoopOnce;
        actionLeft.reset().setDuration(0.2).play();

        window.mouse = {
          x: Math.random() * (600 - 500) + 500,
          y: Math.random() * (800 - 700) + 700,
        };

        console.log("--> Blink ", rand, window.mouse);

        let actionHappy = actions.defaultExpressions_Happy;
        actionHappy.loop = THREE.LoopOnce;
        actionHappy
          .reset()
          .setEffectiveWeight(0.2)
          .setDuration(1)
          .fadeOut(0.3)
          .play();
        loop();
      }, rand);
    }
    // loop();

    let previousAction;
    let activeAction = actions.defaultExpressions_Anger;

    window.fadeToAction = (action, duration) => {
      previousAction = activeAction;
      activeAction = action;

      if (previousAction && previousAction !== activeAction) {
        previousAction.fadeOut && previousAction.fadeOut(duration);
      }

      activeAction
        .reset()
        .setDuration(duration)
        .setEffectiveWeight(1)
        .fadeIn(duration)
        .play();
    };

    playIdle();

    return () => {
      loop = () => {};
    };
  }, []);

  useEffect(() => {
    mesh.current.traverse((item) => {
      if (item.geometry) {
        console.log(item.name);
        item.castShadow = true;
        item.receiveShadow = true;
      }
    }, true);
  }, [mesh]);

  const [mixer] = useState(() => new THREE.AnimationMixer());

  useFrame((delta) => {
    mixer.update(delta);

    // if (window.mouse) moveJoint(window.mouse, nodes.Neck);

    return;
  });

  return (
    <Suspense fallback={null}>
      <primitive object={scene} ref={mesh} />
    </Suspense>
  );
}
